import React, { useMemo } from "react";
import { TransactionListItemDto } from "../../../common/types/transaction";
import { useAccounts } from "../../../hooks/useAccounts";

interface Props {
    transaction: TransactionListItemDto;
}

export const TransactionCoaAccountColumnContent: React.FC<Props> = ({
    transaction,
}) => {
    const accounts = useAccounts({ entityId: transaction.entity.id });

    const account = useMemo(() => {
        const accountId =
            transaction.accountId ??
            transaction.journalEntries
                ?.toSorted((a, b) => (b.lineOrder ?? 0) - (a.lineOrder ?? 0))
                .at(transaction.amount >= 0 ? 0 : 1)?.accountId;

        return accounts?.accounts.find((a) => a.id === accountId);
    }, [
        accounts,
        transaction.accountId,
        transaction.journalEntries,
        transaction.amount,
    ]);

    return `${account?.code} - ${account?.name}`;
};
